window.ActionForm = Block.extend({

    initialize: function (app, data, $dom, xml) {
        Block.prototype.initialize.call(this, app, data, $dom, xml);

        this.actionsManager = this.app.getComponent("ActionsManager");

        this.load();
    },

    load: function() {
        var id = this.app.router.query;
        if(id != null) {
            this.action = this.actionsManager.getAction(id);
        } else {
            var data = this.app.storage.getItem(ActionsManager.ACTION_DATA_KEY);
            data = data === -1 ? {} : data;

            this.action = new Action(data);
            this.app.storage.deleteItem(ActionsManager.ACTION_DATA_KEY);
        }

        Logger.trace("ActionForm.initialize:", this.action);
    },

    render: function() {
        var content = this.getContent(this.data);
        this.$el.html(content);

        this.$form = this.$el.find("form");
        this.$title = this.$form.find("#title");
        this.$limit = this.$form.find("#limit");
        this.$verb = this.$form.find("#verb");
        this.$noun = this.$form.find("#noun");

        this.textArea = new TextArea({
            id: "custom",
            rows: 4,
            value: this.data.custom,
            placeholder: this.data.customPlaceholder,
            maxLength: this.data.maxCustomLength,
            useCharCounter: true,
            disabled: this.data.isConfirmed,
        });
        this.$form.append(this.textArea.$el);

        this.setupButtons();

        OverviewAnimation.animateIn(this.$el.find(".overview"));
    },

    setupButtons: function() {
        var saveButton = new Button({
            el: this.$el.find(".save-button")
        });
        this.listenTo(saveButton, "onClick", this.handleSaveClicked);

        var cancelButton = new Button({
            el: this.$el.find(".cancel-button")
        });
        this.listenTo(cancelButton, "onClick", this.handleCancelClicked);
    },

    handleSaveClicked: function() {
        if(this.$title[0].validity.valid) {
            this.updateActionsData();
            this.actionsManager.addAction(this.action);
            this.app.router.returnToCourse();
        } else {
            this.$form.addClass("submitted");
        }
    },

    handleCancelClicked: function() {
        this.app.router.returnToCourse();
    },

    updateActionsData: function() {
        var limit = this.$limit.val();
        if(limit != -1) this.action.setLimit(limit);

        var verb = this.$verb.val();
        if(verb != -1) this.action.setVerb(verb);

        this.action.setTitle(this.$title.val());
        this.action.setNoun(this.$noun.val());
        this.action.setCustom(this.textArea.getValue());
    },

    getContent: function(data) {
        return Handlebars.templates["actionplan/actionform"](data);
    },

    getData: function($xml, language) {
        var data = {};

        data.title = this.blockData.title();
        data.limits = [];
        data.verbs = [];

        var limit = this.action.getLimit();
        var verb = this.action.getVerb();

        var $fields = $xml.find("row");
        var $limits = $fields.eq(0).find("index").children();
        var $verbs = $fields.eq(1).find("index").children();

        if($limits.length > 0) {
            $limits.each(function() {
                var $this = $(this);
                var text = $this.find("en text").text().trim();

                if(text != "") data.limits.push({
                    limit: text,
                    isSelected: text === limit
                });
            });
        } else {
            Logger.warn("ActionForm.getData", "no limits found");
        }

        if($verbs.length > 0) {
            $verbs.each(function() {
                var $this = $(this);
                var text = $this.find("en text").text().trim();

                if(text != "") data.verbs.push({
                    verb: text,
                    isSelected: text === verb
                });
            });
        } else {
            Logger.warn("ActionForm.getData", "no verbs found");
        }

        data.actionTitle = this.action.getTitle();
        data.noun = this.action.getNoun();
        data.custom = this.action.getCustom();

        data.actualCustomLength = data.custom != null ? data.custom.length : 0;

        data.titlePlaceholder = LanguageManager.getString("title");
        data.nounPlaceholder = LanguageManager.getString("noun_placeholder");
        data.customPlaceholder = LanguageManager.getString("custom_placeholder");
        data.select = LanguageManager.getString("select");
        data.limitLabel = LanguageManager.getString("limit_label");
        data.verbLabel = LanguageManager.getString("verb_label");
        data.saveLabel = LanguageManager.getString("save");
        data.cancelLabel = LanguageManager.getString("cancel");
        data.isConfirmed = this.app.storage.getItem(ActionsManager.ACTION_PLAN_CONFIRMED_KEY) === true;

        data.maxTitleLength = ActionsManager.MAX_TITLE_LENGTH;
        data.maxNounLength = ActionsManager.MAX_NOUN_LENGTH;
        data.maxCustomLength = ActionsManager.MAX_CUSTOM_LENGTH;

        return data;
    },

    destroy: function() {
        this.textArea.destroy();

        Block.prototype.destroy.call(this);
    }
});
